import { format } from "date-fns";

// format date to "YYYY-MM-DD"
export const formatDateForBE = (inputDate: Date | null) => {
  if (!inputDate) return "";
  const year = inputDate.toLocaleString("default", { year: "numeric" });
  const month = inputDate.toLocaleString("default", {
    month: "2-digit",
  });
  const date = inputDate.toLocaleString("default", { day: "2-digit" });

  return `${year}-${month}-${date}`;
};

// format "YYYY-MM-DD" to "dd.MM.yyyy"
export const formatDateStringForUI = (dateString: string) => {
  if (!dateString) return "";
  if (isNaN(new Date(dateString) as any)) return "";
  return format(new Date(dateString), "dd.MM.yyyy");
};

export const getMostRecentPastDateFromArray = (dateArray: string[]) => {
  const currentTimestamp = Date.now();
  const dateTimestamps = dateArray.map((dateString) =>
    new Date(dateString).getTime(),
  );

  // filter out future timestamps
  const pastTimestamps = dateTimestamps.filter(
    (timestamp) => timestamp < currentTimestamp,
  );

  // get most recent timestamp
  const mostRecentTimestamp = Math.max(...pastTimestamps);
  const mostRecentDate = new Date(mostRecentTimestamp);

  return formatDateForBE(mostRecentDate);
};
